import React, { useState, useEffect, useRef, useCallback } from "react"
import MetaTags from 'react-meta-tags';
import Select from "react-select"
import ReactDrawer from 'react-drawer';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  InputGroup,
  Input,
  Label,
  Tooltip,
  Row,
  Button
} from "reactstrap"

import * as moment from "moment"
import { Link , Redirect, useHistory} from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert"
import "flatpickr/dist/themes/airbnb.css"
import Flatpickr from "react-flatpickr"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PurchaseMoreDrawer from "../../components/Common/PurchaseMoreDrawer"
import SimpleBar from "simplebar-react"
import { useHotkeys } from 'react-hotkeys-hook';
import Loader from "components/Common/Loader"
import { getAllSuppliers as onGetAllSuppliers } from "store/products/actions"
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import { getLedgerDetails as onGetLedgerDetails } from "store/products/actions"
import { getProductsDropDownFromCache, storeLastDraftPurchase } from "helpers/cache_helper"
import { round, getNextNonDisabledField } from "helpers/function_helper"
import { setTimeCounter } from "store/products/actions"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { getPurchaseEntryForEditDirect,  getNextPurchaseId, getPreviousPurchaseId } from "helpers/backend_helper"
import COADropDown from "../../components/Product/COADropDown"

const PurchaseEntry = (props) => {

  const history = useHistory()
  const dispatch = useDispatch()

  const options = {
    filter: undefined,
    filterPreventDefault: true,
    enableOnTags: ['INPUT'],
    enabled: true,
    splitKey: '+',
    keyup: undefined,
    keydown: true
  };

  useHotkeys('enter', (event, handler)=> {
    //console.log('enter pressed')
    if(event.target.type == 'button'){
      return
    }
    const form = event.target.form;
    let index = [...form].indexOf(event.target);

    //skipping to loading charges, if no value is selected
    if(form.elements[index] && form.elements[index].id){
      const fieldId = form.elements[index].id
      if(fieldId.startsWith('purch-qty-')){
        const idx = fieldId.substring(10,11)
        if(purchaseRows[idx-1]){
          const lastPurchase = purchaseRows[idx-1]
          if(lastPurchase.productid == '' && lastPurchase.productqty == '0'){
            document.getElementById('freight-charges').focus();
            document.getElementById('freight-charges').select();
            return;
          }
        }
      }
    }

    const nextIdx = getNextNonDisabledField(index,form)
    form.elements[nextIdx].focus();
    if(form.elements[nextIdx].type == 'text' || form.elements[nextIdx].type == 'textarea'){
      form.elements[nextIdx].select();
    }
    event.preventDefault();
  }, options)

  useEffect(() => {
    dispatch(onGetAllSuppliers(true))
    dispatch(onGetStoreSettings(true))
    dispatch(onGetLedgerDetails({'inputKey':'PURCHASE_ACCOUNTS'},true))
    getPdtDropDown()
  }, [dispatch]);

  async function getPdtDropDown(){
    //const pdtdropdown = await getProductsDropDown()
    const pdtdropdown = await getProductsDropDownFromCache(true)
    setProductList(pdtdropdown)
  }

  async function getPdtDropDownFromServer(){
    setIsDoingRefreshing(true)
    const pdtdropdown = await getProductsDropDownFromCache(false)
    setProductList(pdtdropdown)
    setIsDoingRefreshing(false)
  }

  const getAnewRow = (index) => {
    return { 
      idx: index , 
      id:"", 
      value: "",
      productid: "",
      productname: "",
      productqty: "0",
      productrate: "0",
      productgross: "0",
      productdisc: "0",
      productdiscpercentage: "0",
      productnet: "0",
      producttotal: "0",
      cgstpercentage: "0",
      sgstpercentage: "0",
      igstpercentage: "0",
      productcgst: "0",
      productsgst: "0",
      productigst: "0",
      rateperitem: "0",
      profitpercentage: "0",
      profitamount:"0",
      mrppercentage:"0",
      mrp:"0",
      retailpercentage:"0",
      retailprice:"0",
      wholesalepercentage:"0",
      wholesaleprice:"0",
      onlinepercentage:"0",
      onlineprice:"0",
      onlinehighlightedpercentage:"0",
      onlinehighlightedprice:"0",
      addedmoredetails: false,
      purchaseRateType: 'rprate',

      currentbaseprice:"",
      currentmrp:"",
      currentretailprice:"",
      currentwholesaleprice:"",
      currentonlineprice:"",
      currentonlinehighlightedprice :"",

      sellrateperitem :"",
      sellmrp :"",
      sellretailprice :"",
      sellwholesaleprice :"",
      sellonlineprice :"",
      sellonlinehighlightedprice :"",

      multiunit : false,
      unitid :"",
      unitname :"",
      otherunitsprice:[],
      purchaseaccountid : "",
      purchasediscountaccountid : "",
      purchasereturnaccountid :"",
      saleaccountid :"",
      salediscountaccountid :"",
      salereturnaccountid :"",

    }
  }

  const [savedSuccessFully, setSavedSuccessFully] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [isEdit, setIsEdit] = useState(false)
  const [confirmationId, setConfirmationId] = useState('')
  const [submitClicked, setSubmitClicked] = useState(false)
  
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)

  const [position, setPosition] = useState()
  const [currentItemForMoreDetails, setCurrentItemForMoreDetails] = useState({})
  const [open, setOpen] = useState(false)
  const [showLoading, setShowLoading] = useState(false)
  const [selectedSupplier, setSelectedSupplier] = useState(null)
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState(null)
  const [productList, setProductList] = useState([])
  const [purchaseEntryForEdit, setPurchaseEntryForEdit] = useState({})
  const [profitPercentageSettings, setProfitPercentageSettings] = useState({
    global: "0",
    mrp: "0",
    retail: "0",
    wholesale: "0",
    online : "0",
    onlinehighlihted : "0"
  })
  const [purchaseRows, setPurchaseRows] = useState([getAnewRow(1)])
  const [ecomEnabled,setEcomEnabled] = useState(false)
  const [roundOffCheck, setRoundOffCheck] = useState(true)
  const [isDoingRefreshing, setIsDoingRefreshing] = useState(false)

  function initialisePurchaseEntry (){
    return {
      entrydate: moment(new Date()).format("yyyy-MM-DD"),
      invoicedate: moment(new Date()).format("yyyy-MM-DD"),
      id:"",
      status:"",
      suppinvoiceno: "",
      supplierid: "",
      suppinvoiceamount: "",
      purchaseaccountid: "",
      
      totalqty: "0",
      totalgross: "0",
      totaldisc: "0",
      totalnet: "0",
      totalcgst: "0",
      totalsgst: "0",
      totaligst: "0",
      totaltotal: "0",
  
      freightcharges: "0.00",
      othercharges: "0.00",
      discounts: "0.00",
      roundoff: "0.00",
      cashpaid: "0.00",
      balanceamount: "0.00",
      grandtotal: "0.00",
      notes: "",
      purchaseRows:[],
      purchaseRowsToRemove:[],
      
    }
  }
  const [purchaseEntry, setPurchaseEntry] = useState(initialisePurchaseEntry())

  const [validation, setValidation] = useState({
    entrydate: null,
    invoicedate: null,
    suppinvoiceno: null,
  })

  const { supplierList, settings} = useSelector(state => ({
    supplierList: state.Products.suppliers,
    settings: state.Products.settings,
  }))

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      setIsEdit(true)
      setShowLoading(true)
      getPurchaseEntryDetails(params.id)
    } 
  }, [])

  async function getPurchaseEntryDetails(pdtid){
    const response = await getPurchaseEntryForEditDirect(pdtid)
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.id){
      setPurchaseEntryForEdit((response))
    }
    setShowLoading(false)
  }

  useEffect(() => {
    if(isEdit && supplierList && supplierList.length > 0 && purchaseEntryForEdit&&purchaseEntryForEdit.supplierid){
        const suppOption = supplierList.filter(each => each.value === purchaseEntryForEdit.supplierid)
        if(suppOption && suppOption.length == 1){
          setSelectedSupplier(suppOption[0])
        }
    }
  }, [supplierList]);

  useEffect(() => {
    if (purchaseEntryForEdit && isEdit && params.id == purchaseEntryForEdit.id) {
      
      let purchaseRowsTemp = []
      let index = 1;

      const grandtotaltempafterround = Math.round(purchaseEntryForEdit.grandtotal)
      const roundofftemp = Number((grandtotaltempafterround) - Number(purchaseEntryForEdit.grandtotal)).toFixed(2)

      if(roundofftemp != 0 && Number(purchaseEntryForEdit.roundoff) == 0){
        setRoundOffCheck(false)
      }

      purchaseEntryForEdit.purchaseRows.forEach(each => {
        let productname = ''
        let cgstper = '0'
        let sgstper = '0'
        let igstper = '0'
        let unitidtemp = ''
        let unidnametemp = ''
        let multiunittemp = false

        let currentbasepricetemp = ''
        let currentmrptemp = ''
        let currentretailpricetemp = ''
        let currentwholesalepricetemp = ''
        let currentonlinepricetemp = ''
        let currentonlinehighlightedpricetemp = ''

        let purchaseaccountidtemp = ''
        let purchasediscountaccountidtemp = ''
        let purchasereturnaccountidtemp = ''
        let saleaccountidtemp = ''
        let salediscountaccountidtemp = ''
        let salereturnaccountidtemp = ''

        if(productList && productList.length > 0){
          const foundValue = productList.filter(x => x["productid"] == each.productid)
          if(foundValue && foundValue.length == 1){
            productname = foundValue[0].label
            cgstper = foundValue[0].cgst
            sgstper = foundValue[0].sgst
            igstper = foundValue[0].igst
            unitidtemp = foundValue[0].unitid
            unidnametemp = foundValue[0].unitname
            multiunittemp = foundValue[0].multiunit

            purchaseaccountidtemp = foundValue[0].purchaseaccountid
            purchasediscountaccountidtemp = foundValue[0].purchasediscountaccountid
            purchasereturnaccountidtemp = foundValue[0].purchasereturnaccountid
            saleaccountidtemp = foundValue[0].saleaccountid
            salediscountaccountidtemp = foundValue[0].salediscountaccountid
            salereturnaccountidtemp = foundValue[0].salereturnaccountid

            currentbasepricetemp = foundValue[0].baseprice == "0" ? "" : foundValue[0].baseprice
            currentmrptemp = foundValue[0].mrp == "0" ? "" : foundValue[0].mrp
            currentretailpricetemp = foundValue[0].retailprice == "0" ? "" : foundValue[0].retailprice
            currentwholesalepricetemp = foundValue[0].wholesaleprice == "0" ? "" : foundValue[0].wholesaleprice
            currentonlinepricetemp = foundValue[0].onlineprice == "0" ? "" : foundValue[0].onlineprice
            currentonlinehighlightedpricetemp = foundValue[0].onlinehighlightedprice == "0" ? "" : foundValue[0].onlinehighlightedprice

          }
        }
        purchaseRowsTemp.push({
          ...each,
          idx: index++ , 
          value: each.id,
          productname: productname,
          cgstpercentage: cgstper,
          sgstpercentage: sgstper,
          igstpercentage: igstper,
          unitid : unitidtemp,
          unitname : unidnametemp,
          multiunit : multiunittemp,
          profitpercentage: "0",
          profitamount:"0",
          addedmoredetails:true,
          currentbaseprice: currentbasepricetemp,
          currentmrp: currentmrptemp,
          currentretailprice: currentretailpricetemp,
          currentwholesaleprice: currentwholesalepricetemp,
          currentonlineprice: currentonlinepricetemp,
          currentonlinehighlightedprice: currentonlinehighlightedpricetemp,
          purchaseaccountid : purchaseaccountidtemp,
          purchasediscountaccountid : purchasediscountaccountidtemp,
          purchasereturnaccountid :purchasereturnaccountidtemp,
          saleaccountid :saleaccountidtemp,
          salediscountaccountid :salediscountaccountidtemp,
          salereturnaccountid :salereturnaccountidtemp,

          sellrateperitem :  each.rateperitem,
          sellmrp : each.mrp,
          sellretailprice : each.retailprice,
          sellwholesaleprice : each.wholesaleprice,
          sellonlineprice : each.onlineprice,
          sellonlinehighlightedprice : each.onlinehighlightedprice,
          purchaseRateType: each.purchaseRateType,
        })
      })

      if(purchaseRowsTemp.length == 0){
        purchaseRowsTemp.push(getAnewRow(1))
      }
      setPurchaseRows(purchaseRowsTemp)
      if(supplierList && supplierList.length > 0 && purchaseEntryForEdit.supplierid){
        const suppOption = supplierList.filter(each => each.value === purchaseEntryForEdit.supplierid)
        if(suppOption && suppOption.length == 1){
          setSelectedSupplier(suppOption[0])
        }
      }

      /*
      if(purchaseaccounts && purchaseaccounts.length > 0 && purchaseEntryForEdit.purchaseaccountid){
        const pAcntOption = purchaseaccounts.filter(each => each.value === purchaseEntryForEdit.purchaseaccountid)
        if(pAcntOption && pAcntOption.length == 1){
          setSelectedPurchaseAccount(pAcntOption[0])
        }
      }
      */

      setPurchaseEntry({
        ...purchaseEntry,
        id: purchaseEntryForEdit.id,
        status: purchaseEntryForEdit.status,
        entrydate: purchaseEntryForEdit.entrydate,
        invoicedate: purchaseEntryForEdit.invoicedate,
        suppinvoiceno: purchaseEntryForEdit.suppinvoiceno,
        supplierid: purchaseEntryForEdit.supplierid,
        suppinvoiceamount: purchaseEntryForEdit.suppinvoiceamount,
        purchaseaccountid: purchaseEntryForEdit.purchaseaccountid,
        
        totalqty: purchaseEntryForEdit.totalqty,
        totalgross: purchaseEntryForEdit.totalgross,
        totaldisc: purchaseEntryForEdit.totaldisc,
        totalnet: purchaseEntryForEdit.totalnet,
        totalcgst: purchaseEntryForEdit.totalcgst,
        totalsgst: purchaseEntryForEdit.totalsgst,
        totaligst: purchaseEntryForEdit.totaligst,
        totaltotal: purchaseEntryForEdit.totaltotal,

        freightcharges: purchaseEntryForEdit.freightcharges,
        othercharges: purchaseEntryForEdit.othercharges,
        discounts: purchaseEntryForEdit.discounts,
        roundoff: purchaseEntryForEdit.roundoff,
        cashpaid: purchaseEntryForEdit.cashpaid,
        balanceamount: purchaseEntryForEdit.balanceamount,
        grandtotal: purchaseEntryForEdit.grandtotal,
        notes: purchaseEntryForEdit.notes,
        purchaseRows:purchaseRowsTemp
      })
    }
  },[purchaseEntryForEdit])

  useEffect(() => {
    //console.log('settings:'+JSON.stringify(settings))
    if(settings && settings.length > 0){
      let globalpp = "0";
      let mrpperc = "0";
      let retailperc = "0";
      let onlineperc = "0";
      let onlinehighlightedperc = "0";
      let wholesaleperc = "0";
      settings.forEach(each => {
        if(each["settingid"] && each["settingid"] == 'PROFIT_PERCENTAGE_GLOBAL'){
          globalpp = each["settingvalue"] 
        }
        else if(each["settingid"] && each["settingid"] == 'PROFIT_PERCENTAGE_MRP'){
          mrpperc = each["settingvalue"] 
        }
        else if(each["settingid"] && each["settingid"] == 'PROFIT_PERCENTAGE_RETAIL'){
          retailperc = each["settingvalue"] 
        }
        else if(each["settingid"] && each["settingid"] == 'PROFIT_PERCENTAGE_ONLINE'){
          onlineperc = each["settingvalue"] 
        }
        else if(each["settingid"] && each["settingid"] == 'PROFIT_PERCENTAGE_WHOLESALE'){
          wholesaleperc = each["settingvalue"] 
        }
        else if(each["settingid"] && each["settingid"] == 'PROFIT_PERCENTAGE_ONLINE_HIGHLIGHT'){
          onlinehighlightedperc = each["settingvalue"] 
        }
        else if(each["settingid"] && each["settingid"] == 'ECOMMERCE_FLAG' && each["settingvalue"] == 'Yes'){
          setEcomEnabled(true)
        }
      })

      if(mrpperc == "0"){
        mrpperc = globalpp
      }
      if(retailperc == "0"){
        retailperc = globalpp
      }
      if(wholesaleperc == "0"){
        wholesaleperc = globalpp
      }
      if(onlineperc == "0"){
        onlineperc = globalpp
      }
      if(onlinehighlightedperc == "0"){
        onlinehighlightedperc = onlineperc
      }

      setProfitPercentageSettings({
        global: globalpp,
        mrp: mrpperc,
        retail: retailperc,
        wholesale: wholesaleperc,
        online : onlineperc,
        onlinehighlihted : onlinehighlightedperc
      })
    }
  }, [settings]);

  const mandatoryFields = ['invoicedate','suppinvoiceno','supplierid']

  const onChangeValidation = (fieldName, value) => {
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }

  useEffect(() => {
    let totalqtytemp = 0
    let totalgrosstemp = 0
    let totaldisctemp = 0
    let totalnettemp = 0
    let totalcgsttemp = 0
    let totalsgsttemp = 0
    let totaligsttemp = 0
    let totaltotaltemp = 0
    purchaseRows.forEach(each => {
      totalqtytemp = totalqtytemp + Number(each["productqty"])
      totalgrosstemp = totalgrosstemp + Number(each["productgross"])
      totaldisctemp = totaldisctemp + Number(each["productdisc"])
      totalnettemp = totalnettemp + Number(each["productnet"])
      totalcgsttemp = totalcgsttemp + Number(each["productcgst"])
      totalsgsttemp = totalsgsttemp + Number(each["productsgst"])
      totaligsttemp = totaligsttemp + Number(each["productigst"])
      totaltotaltemp = totaltotaltemp + Number(each["producttotal"])
    })

    let grandtotaltemp = totaltotaltemp + Number(purchaseEntry.freightcharges) + Number(purchaseEntry.othercharges) - Number(purchaseEntry.discounts)
    
    let roundofftemp = "0.00"

    if(roundOffCheck){
      const grandtotaltempafterround = Math.round(grandtotaltemp)
      roundofftemp = Number(grandtotaltempafterround - grandtotaltemp).toFixed(2)
      grandtotaltemp = grandtotaltempafterround
    }
    
    setPurchaseEntry({
      ...purchaseEntry,
      totalqty: Number(totalqtytemp).toFixed(2),
      totalgross: Number(totalgrosstemp).toFixed(2),
      totaldisc: Number(totaldisctemp).toFixed(2),
      totalnet: Number(totalnettemp).toFixed(2),
      totalcgst: Number(totalcgsttemp).toFixed(2),
      totalsgst: Number(totalsgsttemp).toFixed(2),
      totaligst: Number(totaligsttemp).toFixed(2),
      totaltotal: Number(totaltotaltemp),
      roundoff : roundofftemp,
      balanceamount: (Number(grandtotaltemp) - Number(purchaseEntry.cashpaid)),
      grandtotal: Number(grandtotaltemp),
      purchaseRows:purchaseRows
    })
  }, [purchaseRows]);

  function getGrossFromRow(currentRow){
    if(isNumber(currentRow["productqty"]) && isNumber(currentRow["productrate"])){
      return (Number(currentRow["productqty"]) * Number(currentRow["productrate"])).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getNetFromRow(currentRow){
    if(isNumber(currentRow["productgross"]) && isNumber(currentRow["productdisc"])){
      return (currentRow["productgross"] - currentRow["productdisc"]).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getDiscountFromRow(currentRow){
    if(isNumber(currentRow["productgross"]) && isNumber(currentRow["productdiscpercentage"])){
      return ((currentRow["productgross"] * currentRow["productdiscpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getCGSTFromRow(currentRow){
    if(isNumber(currentRow["productnet"]) && isNumber(currentRow["cgstpercentage"])){
      return ((currentRow["productnet"] * currentRow["cgstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getSGSTFromRow(currentRow){
    if(isNumber(currentRow["productnet"]) && isNumber(currentRow["sgstpercentage"])){
      return ((currentRow["productnet"] * currentRow["sgstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getIGSTFromRow(currentRow){
    if(isNumber(currentRow["productnet"]) && isNumber(currentRow["igstpercentage"])){
      return ((currentRow["productnet"] * currentRow["igstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getTotalFromRow(currentRow){
    const total = Number(currentRow["productnet"]) + Number(currentRow["productcgst"]) + Number(currentRow["productsgst"]) + Number(currentRow["productigst"])
    return Number(total).toFixed(2)
  }

  function getRatePerItemFromRow(currentRow){
    return (Number(currentRow["producttotal"])/Number(currentRow["productqty"])).toFixed(2)
  }

  function getProfitForEachFromRow(currentRow){
    return (Number(currentRow["rateperitem"]) * Number(currentRow["profitpercentage"])/100).toFixed(2)
  }

  function getMRPForEachFromRow(currentRow){
    return (Number(currentRow["rateperitem"]) + (Number(currentRow["rateperitem"]) * Number(currentRow["mrppercentage"])/100)).toFixed(2)
  }
  function getRetailForEachFromRow(currentRow){
    return (Number(currentRow["rateperitem"]) + (Number(currentRow["rateperitem"]) * Number(currentRow["retailpercentage"])/100)).toFixed(2)
  }
  function getWholeSaleForEachFromRow(currentRow){
    return (Number(currentRow["rateperitem"]) + (Number(currentRow["rateperitem"]) * Number(currentRow["wholesalepercentage"])/100)).toFixed(2)
  }
  function getOnlineForEachFromRow(currentRow){
    return (Number(currentRow["rateperitem"]) + (Number(currentRow["rateperitem"]) * Number(currentRow["onlinepercentage"])/100)).toFixed(2)
  }
  function getOnlineHighlightedForEachFromRow(currentRow){
    return (Number(currentRow["rateperitem"]) + (Number(currentRow["rateperitem"]) * Number(currentRow["onlinehighlightedpercentage"])/100)).toFixed(2)
  }

  function handleProductChangeV2(id, productoption) {
    var modifiedRows = [...purchaseRows]

    /*
    let result = purchaseRows.filter(x => x["idx"]==id)[0]
    console.log('result:'+JSON.stringify(result))
  */
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        const defaultunit = productoption.units[0]
        eachRow["productrate"] = defaultunit.baseprice
        eachRow["cgstpercentage"] = productoption.cgst
        eachRow["sgstpercentage"] = productoption.sgst
        eachRow["igstpercentage"] = productoption.igst

        eachRow["unitid"] = productoption.unitid
        eachRow["unitname"] = productoption.unitname
        eachRow["multiunit"] = productoption.multiunit
        eachRow = recalculateEachRow(eachRow)

        return {
          ...eachRow,
          //id:productoption.productid, 
          //value: productoption.productid,
          productid: productoption.productid,
          productname: productoption.label,
          cgstpercentage: productoption.cgst,
          sgstpercentage: productoption.sgst,
          igstpercentage: productoption.igst,
          purchaseaccountid : productoption.purchaseaccountid,
          purchasediscountaccountid : productoption.purchasediscountaccountid,
          purchasereturnaccountid :productoption.purchasereturnaccountid,
          saleaccountid :productoption.saleaccountid,
          salediscountaccountid :productoption.salediscountaccountid,
          salereturnaccountid :productoption.salereturnaccountid,

          currentbaseprice: productoption.baseprice == "0" ? "" : productoption.baseprice,
          currentmrp: productoption.mrp == "0" ? "" : productoption.mrp,
          currentretailprice: productoption.retailprice == "0" ? "" : productoption.retailprice,
          currentwholesaleprice: productoption.wholesaleprice == "0" ? "" : productoption.wholesaleprice,
          currentonlineprice: productoption.onlineprice == "0" ? "" : productoption.onlineprice,
          currentonlinehighlightedprice: productoption.onlinehighlightedprice == "0" ? "" : productoption.onlinehighlightedprice,
        }
      }
      else {
        return eachRow
      }
    })
    setPurchaseRows(modifiedRows)
  }

  function handleQtyChangeV2(id, value) {
    var modifiedRows = [...purchaseRows]

    modifiedRows = modifiedRows.map(eachRow => {

      if(eachRow["idx"] == id){

        eachRow["productqty"] = value
        eachRow = recalculateEachRow(eachRow)

        return {
          ...eachRow,
          productqty: value,
        }
      }
      else {
        return eachRow
      }
    })
    setPurchaseRows(modifiedRows)
  }

  function recalculateEachRow(eachRow){

    eachRow["productgross"] = getGrossFromRow(eachRow)
    eachRow["productdisc"] = getDiscountFromRow(eachRow)
    eachRow["productnet"] = getNetFromRow(eachRow)
    eachRow["productcgst"] = getCGSTFromRow(eachRow)
    eachRow["productsgst"] = getSGSTFromRow(eachRow)
    eachRow["productigst"] = getIGSTFromRow(eachRow)
    eachRow["producttotal"] = getTotalFromRow(eachRow)

    if(eachRow["profitpercentage"] == "0"){
      eachRow["profitpercentage"] = profitPercentageSettings.global || "0"
    }
    if(eachRow["mrppercentage"] == "0"){
      eachRow["mrppercentage"] = profitPercentageSettings.mrp || "0"
    }
    if(eachRow["retailpercentage"] == "0"){
      eachRow["retailpercentage"] = profitPercentageSettings.retail || "0"
    }
    if(eachRow["wholesalepercentage"] == "0"){
      eachRow["wholesalepercentage"] = profitPercentageSettings.wholesale || "0"
    }
    if(eachRow["onlinepercentage"] == "0"){
      eachRow["onlinepercentage"] = profitPercentageSettings.online || "0"
    }
    if(eachRow["onlinehighlightedpercentage"] == "0"){
      eachRow["onlinehighlightedpercentage"] = profitPercentageSettings.onlinehighlihted || "0"
    }

    eachRow["rateperitem"] = getRatePerItemFromRow(eachRow)
    eachRow["profitamount"] = getProfitForEachFromRow(eachRow)
   
    eachRow["mrp"] = getMRPForEachFromRow(eachRow)
    eachRow["retailprice"] = getRetailForEachFromRow(eachRow)
    eachRow["wholesaleprice"] = getWholeSaleForEachFromRow(eachRow)
    eachRow["onlineprice"] = getOnlineForEachFromRow(eachRow)
    eachRow["onlinehighlightedprice"] = getOnlineHighlightedForEachFromRow(eachRow)

    return eachRow
  }

  function handleRateChangeV2(id, value) {
    var modifiedRows = [...purchaseRows]
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        eachRow["productrate"] = value
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow,
          productrate: value,
        }
      }
      else {
        return eachRow
      }
    })
    setPurchaseRows(modifiedRows)
  }

  function handleDiscPercentageChangeV2(id, value) {
    var modifiedRows = [...purchaseRows]

    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        eachRow["productdiscpercentage"] = value
        eachRow["productdisc"] = getDiscount(eachRow["productgross"],value)
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow,
          productdiscpercentage: value,
        }
      }
      else {
        return eachRow
      }
    })
    setPurchaseRows(modifiedRows)
  }

  function handleDiscountChangeV2(id, value) {
    var modifiedRows = [...purchaseRows]

    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id && (Number(eachRow["productgross"]) >= Number(value))){
        eachRow["productdisc"] = value
        eachRow["productdiscpercentage"] = getDiscountPercentage(eachRow["productgross"],value)
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow,
          productdisc: value,
        }
      }
      else {
        return eachRow
      }
    })
    setPurchaseRows(modifiedRows)
  }

  function getNet(gross,disc){
    if(isNumber(gross) && isNumber(disc)){
      return (Number(gross) - Number(disc)).toFixed(2)
    }
    else{
      return Number(2).toFixed(2)
    }
  }

  function getGross(qty,rate){
    if(isNumber(qty) && isNumber(rate)){
      return (Number(qty) * Number(rate)).toFixed(2)
    }
    else{
      return ""
    }
  }

  function getDiscount(gross,rate){
    if(isNumber(gross) && isNumber(rate)){
      return ((Number(gross) * Number(rate))/100).toFixed(2)
    }
    else{
      return "0"
    }
  }

  function getDiscountPercentage(gross,discont){
    if(isNumber(gross) && isNumber(discont) && Number(gross) > 0){
      return ((Number(discont) * 100)/Number(gross)).toFixed(2)
    }
    else{
      return "0"
    }
  }

  function getTaxFromPercentage(total,tax){
    if(isNumber(total) && isNumber(tax)){
      return ((Number(total) * Number(tax))/100).toFixed(2)
    }
    else{
      return "0"
    }
  }

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  const onDrawerClose = () => {
    setOpen(false);
  }

  const onNewlyAddedValue = (updatedRecord) => {
    var modifiedRows = [...purchaseRows]

    modifiedRows = modifiedRows.map(row => row["idx"] == updatedRecord["idx"] ? updatedRecord : row)
    
    if(updatedRecord["idx"] == modifiedRows.length){
      modifiedRows.push(getAnewRow(modifiedRows.length + 1))
      setPurchaseRows(modifiedRows)
    }
    else{
      setPurchaseRows(modifiedRows)
    }
    if(submitClicked){

      const purchaseEntryTemp = { ...purchaseEntry }
      purchaseEntryTemp["purchaseRows"] = modifiedRows

      if(isEdit){
        updatePurchaseEntry(purchaseEntryTemp)
      }
      else{
        addPurchaseEntry(purchaseEntryTemp)
      }
    }
    //handleAddPurchaseRows()
  }

  function validatePdtChange(key,value){
    if(value && value != ""){
      setValidation({
        ...validation,
        [key]:true
      })
    }
    else{
      setValidation({
        ...validation,
        [key]:false
      })
    }  
  }

  function validateTextNumberInput(key,value){
    if(value && value != "" && isNumber(value) && Number(value) > 0){
      setValidation({
        ...validation,
        [key]:true
      })
    }
    else{
      setValidation({
        ...validation,
        [key]:true
      })
    }
  }

  function validateForm() {
    const modifiedV = { ...validation }
    
    const lastRow = purchaseRows[purchaseRows.length-1]
    let formValid = true;
    if(lastRow["productid"] && lastRow["productid"] != ""){
      modifiedV["pdtitem-"+(purchaseRows.length)] = true
    }
    else{
      modifiedV["pdtitem-"+(purchaseRows.length)] = false
      formValid = false
    }

    if(lastRow["productqty"] && lastRow["productqty"] != "" && isNumber(lastRow["productqty"]) && Number(lastRow["productqty"]) > 0){
      modifiedV["productqty-"+(purchaseRows.length)] = true
    }
    else{
      modifiedV["productqty-"+(purchaseRows.length)] = false
      formValid = false
    }

    if(lastRow["productrate"] && lastRow["productrate"] != "" && isNumber(lastRow["productrate"]) && Number(lastRow["productrate"]) > 0){
      modifiedV["productrate-"+(purchaseRows.length)] = true
    }
    else{
      modifiedV["productrate-"+(purchaseRows.length)] = false
      formValid = false
    }

    setValidation(modifiedV)
    return formValid
  }

  function validateFormSubmit(){
    let formValid = true;
    const modifiedV = { ...validation }
    mandatoryFields.forEach(eachItem =>{
      if(purchaseEntry[eachItem] && purchaseEntry[eachItem].trim() != ""){
        modifiedV[eachItem] = true
      }
      else{
        modifiedV[eachItem] = false
        formValid = false
      }
    })
    if(purchaseEntry.suppinvoiceamount != "" && Number(purchaseEntry.suppinvoiceamount) > 0){
      if(round(purchaseEntry.suppinvoiceamount,2) != round(purchaseEntry.grandtotal,2)){
        modifiedV["invalidsum"] = false
        formValid = false
      }
      else{
        modifiedV["invalidsum"] = true
      }
    }
    else{
      modifiedV["invalidsum"] = true
    }

    if(purchaseEntry.cashpaid != "" && Number(purchaseEntry.cashpaid) > 0){
      if(Number(purchaseEntry.cashpaid) > Number(purchaseEntry.grandtotal)){
        modifiedV["invalidpaidamt"] = false
        formValid = false
      }
      else{
        modifiedV["invalidpaidamt"] = true
      }
    }
    else{
      modifiedV["invalidpaidamt"] = true
    }

    setValidation(modifiedV)

    return formValid
  }

  function addPurchaseEntry(inputPurchaseEntry){
    let isFormValid = validateFormSubmit()
    if(isFormValid && !submitClicked){
      //Only one possibilty, more details are not added for it
      if(purchaseRows.length == 1){
        addMoreDetails(1, true)
        isFormValid = false;
      }
      else if(purchaseRows.length > 1){
        if((purchaseRows[purchaseRows.length-1].productid != "" 
        || Number(purchaseRows[purchaseRows.length-1].productqty) > 0 
        || Number(purchaseRows[purchaseRows.length-1].productrate) > 0) 
        && purchaseRows[purchaseRows.length-1].addedmoredetails == false){
          addMoreDetails(purchaseRows.length, true)
          isFormValid = false;
        }
      }
    }
    if(isFormValid){
      let purchaseEntryTemp = { ...purchaseEntry }
      if(inputPurchaseEntry){
        purchaseEntryTemp = inputPurchaseEntry
      }
      purchaseEntryTemp["status"] = 'ACTIVE'
      submitCreateNewPurchaseEntry(purchaseEntryTemp)
    }
  }

  function draftPurchaseEntry(){
      const purchaseEntryTemp = { ...purchaseEntry }
      purchaseEntryTemp["status"] = 'DRAFT'
      submitCreateNewPurchaseEntry(purchaseEntryTemp)
  }

  async function handleAddProduct(){

    const purchaseEntryTemp = { ...purchaseEntry }
    purchaseEntryTemp["status"] = 'DRAFT'

    setShowLoading(true)
    const response = await onAddItemDirect(purchaseEntryTemp, 'PurchaseEntry')
    //getPdtDropDown()
    //setShowLoading(false)
    dispatch(setTimeCounter(1500000))
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      storeLastDraftPurchase('/edit-purchaseentry/'+response.confirmation_code)
      history.push('/add-product');
      //setConfirmationId(response.confirmation_code)
    }
    //setShowLoading(false)
  }

  function updateDraftPurchaseEntry(){
    const purchaseEntryTemp = { ...purchaseEntry }
    purchaseEntryTemp["status"] = 'DRAFT'
    submitUpdatePurchaseEntry(purchaseEntryTemp)
  }

  function updatePurchaseEntry(inputPurchaseEntry){
    let isFormValid = validateFormSubmit()
    if(isFormValid && !submitClicked){
      //Only one possibilty, more details are not added for it
      if(purchaseRows.length == 1){
        addMoreDetails(1, true)
        isFormValid = false;
      }
      else if(purchaseRows.length > 1){
        if((purchaseRows[purchaseRows.length-1].productid != "" 
        || Number(purchaseRows[purchaseRows.length-1].productqty) > 0 
        || Number(purchaseRows[purchaseRows.length-1].productrate) > 0)
        && purchaseRows[purchaseRows.length-1].addedmoredetails == false){
          addMoreDetails(purchaseRows.length, true)
          isFormValid = false;
        }
      }
    }
    if(isFormValid){
      let purchaseEntryTemp = { ...purchaseEntry }
      if(inputPurchaseEntry){
        purchaseEntryTemp = inputPurchaseEntry
      }
      purchaseEntryTemp["status"] = 'ACTIVE'
      submitUpdatePurchaseEntry(purchaseEntryTemp)
    }
  }

  async function submitUpdatePurchaseEntry(purchaseEntryDetails) {
    setShowLoading(true)
    const response = await onEditItemDirect(purchaseEntryDetails, 'PurchaseEntry')
    getProductsDropDownFromCache(false)
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      setShowSuccessPopUp(true)
      //setSavedSuccessFully(true)
      setConfirmationId(purchaseEntryDetails.id)
      setPurchaseEntry({
        ...purchaseEntry,
        status: purchaseEntryDetails.status
      })
      setSuccessMessage('Purchase Entry Updated successfully.')
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  async function submitCreateNewPurchaseEntry(purchaseEntryDetails) {
    setShowLoading(true)
    const response = await onAddItemDirect(purchaseEntryDetails, 'PurchaseEntry')
    getProductsDropDownFromCache(false)
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      setPurchaseEntry({
        ...purchaseEntry,
        status: purchaseEntryDetails.status
      })
      setShowSuccessPopUp(true)
      setSavedSuccessFully(true)
      setSuccessMessage('Purchase Entry added successfully.')
      setConfirmationId(response.confirmation_code)
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  function handleRemoveOneRow(formRow, id) {

    var modifiedRows = [...purchaseRows]
    modifiedRows = modifiedRows.filter(x => x["idx"] !== id)

    var updatedRows = [];
    modifiedRows.map((row,index) =>{
      updatedRows.push(
        {
          ...row, 
          idx: index+1
        })
    })

    setPurchaseRows(updatedRows)

    const currentRows = purchaseEntry.purchaseRowsToRemove
    currentRows.push(formRow.id)
    setPurchaseEntry({
      ...purchaseEntry,
      purchaseRowsToRemove : currentRows
    })
  }

  function addMoreDetails(idx, fromFormSubmit) {

    let openDrawer = validateForm()
    /*
    let openDrawer = true;

    if(idx == purchaseRows.length) {
      openDrawer = validateForm()
      //Not opening, if it is already validated. Just adding a new row
      if(openDrawer){
        let currentRows = [...purchaseRows]
        if(currentRows[purchaseRows.length-1].addedmoredetails === true){
          currentRows.push(getAnewRow(purchaseRows.length+1))
          setPurchaseRows(currentRows)
          return
        }
      }
    }
    */

    if(openDrawer){

      if(fromFormSubmit){
        setSubmitClicked(true)
      }

      var modifiedRows = [...purchaseRows]
      const currentRow = modifiedRows.filter(each => each["idx"] == idx)[0]
  
      setPosition('right')
      setOpen(!open)
      setCurrentItemForMoreDetails(currentRow)
    }
    //setNewItemToAdd(item)
  }

  function getSelectedProduct(idx){
    if(productList && purchaseRows && productList.length > 0 && purchaseRows.length > 0){
      const foundValue = productList.filter(x => x["productid"] == purchaseRows[idx-1].productid)
      return foundValue
    }
  }

  function addNewPurchase(){
    setPurchaseRows([getAnewRow(1)])
    const basePurchase = initialisePurchaseEntry()
    setSubmitClicked(false)
    /*
    if(purchaseaccounts && purchaseaccounts.length > 0){
      setSelectedPurchaseAccount(purchaseaccounts[0])
      setPurchaseEntry({
        ...basePurchase,
        purchaseaccountid: purchaseaccounts[0].value,
      })
    }
    else{
      setPurchaseEntry({
        ...basePurchase,
      })
    }*/
    setPurchaseEntry({
      ...basePurchase,
    })
    setSelectedSupplier(null)
    setSavedSuccessFully(false)
    
  }

  const onContinueEditing = () => {
    setShowSuccessPopUp(false)
    if(confirmationId != ''){
      if(isEdit){
        setShowLoading(true)
        getPurchaseEntryDetails(confirmationId)
      }
      history.push('/edit-purchaseentry/'+confirmationId);
    }
    //return  <Redirect  to="/dashboard" />
 }

 const onCreateNewPurchase = () => {
    setShowSuccessPopUp(false)
   if(isEdit){
    history.push('/add-purchase');
   }
   else{
    addNewPurchase()
   }
}

const goToLastPurchase = async () => {
  setShowLoading(true)
  const resp = await getPreviousPurchaseId({})
  if(resp && resp.status && resp.status == 'success' && resp.confirmation_code){
    history.push('/edit-purchaseentry/'+resp.confirmation_code);
  }
  else{
    setShowLoading(false)
    setErrorMessage('No more entries')
    setShowErrorPopUp(true)
  }
}

const goToPreviousPurchase = async () => {
  setShowLoading(true)
  const resp = await getPreviousPurchaseId({
    key: params.id
  })
  if(resp && resp.status && resp.status == 'success' && resp.confirmation_code){
    history.push('/edit-purchaseentry/'+resp.confirmation_code);
    getPurchaseEntryDetails(resp.confirmation_code)
  }
  else{
    setShowLoading(false)
    setErrorMessage('No more entries')
    setShowErrorPopUp(true)
  }
}

const goToNextPurchase = async () => {
  setShowLoading(true)
  const resp = await getNextPurchaseId({
    key: params.id
  })
  if(resp && resp.status && resp.status == 'success' && resp.confirmation_code){
    history.push('/edit-purchaseentry/'+resp.confirmation_code);
    getPurchaseEntryDetails(resp.confirmation_code)
  }
  else{
    setShowLoading(false)
    setErrorMessage('No more entries')
    setShowErrorPopUp(true)
  }
}
  /*
  useEffect(() => {
    console.log('purchaseRows::'+JSON.stringify(purchaseRows))
  }, [purchaseRows]);
  */
 /*
  useEffect(() => {
    console.log('purchaseEntry::'+JSON.stringify(purchaseEntry))
  }, [purchaseEntry]);
  */

  return (
    <React.Fragment>
      <div className="page-content purchase-entry-form">
        <MetaTags>
          <title>Purchase Entry | Flamingo</title>
        </MetaTags>
        <Loader showLoader={showLoading} />
        <Container fluid>
          {/*isEdit ? 
          <Breadcrumbs title="Purchase" breadcrumbItem="Edit Purchase Entry" /> 
          :
          <Breadcrumbs title="Purchase" breadcrumbItem="Purchase Entry" />
          */}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="pt-2">
                  <Form>
                    <Row className="mb-2">
                      <Col></Col>
                      <Col className="text-center font-size-18 fw-bold"><span className="px-3 bg-light ">Purchase Entry</span></Col>
                      <Col className="text-end">
                        <Button
                          color="info"
                          className="btn btn-success btn-sm me-2"
                          onClick={() => {
                            handleAddProduct()
                          }}
                          >
                            <i className="mdi mdi-plus me-1" />
                            ADD PRODUCT
                        </Button>
                        {!isEdit && <Button
                          color="primary"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            goToLastPurchase()
                          }}
                          >
                            <i className="mdi mdi-chevron-left me-1"></i>
                            Previous
                        </Button>
                        }

                        {!isEdit && <Button
                          color="warning"
                          className="btn btn-primary btn-sm  me-2"
                          onClick={() => {
                            addNewPurchase()
                          }}
                          >
                            <i className="mdi mdi-text-box-remove-outline me-1"></i>
                            Clear
                        </Button>
                        }

                        {isEdit && <Button
                          color="primary"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            goToPreviousPurchase()
                          }}
                          >
                            <i className="mdi mdi-chevron-left me-1"></i>
                            Previous
                        </Button>
                        }

                        {isEdit && <Button
                          color="primary"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            goToNextPurchase()
                          }}
                          >
                            Next
                            <i className="mdi mdi-chevron-right ms-1"></i>
                        </Button>
                        }

                        <Button
                          color="primary"
                          disabled={isDoingRefreshing}
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            getPdtDropDownFromServer()
                          }}
                          >
                            Pdt
                            <i className="mdi mdi-reload ms-1"></i>
                        </Button>

                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Entry Date</Label>
                          <InputGroup>
                            <Flatpickr
                              id="entrydatefp"
                              className="form-control d-block"
                              placeholder="dd MM yyyy"
                              value={purchaseEntry.entrydate}
                              options={{
                                altInput: true,
                                altFormat: "j F Y",
                                dateFormat: "Y-m-d",
                                defaultDate: "today"
                              }}
                              onChange={date => {
                                const date1 = moment(new Date(date)).format("yyyy-MM-DD")
                                setPurchaseEntry({
                                  ...purchaseEntry,
                                  entrydate : date1
                                })
                              }}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Invoice Date</Label>
                          <InputGroup>
                            <Flatpickr
                              id="invoicedatefp"
                              className="form-control d-block"
                              placeholder="dd MM yyyy"
                              value={purchaseEntry.invoicedate}
                              options={{
                                altInput: true,
                                altFormat: "j F Y",
                                dateFormat: "Y-m-d",
                              }}
                              onChange={date => {
                                const date1 = moment(new Date(date)).format("yyyy-MM-DD")
                                setPurchaseEntry({
                                  ...purchaseEntry,
                                  invoicedate : date1
                                })
                                onChangeValidation("invoicedate", date1)
                              }}
                            />
                            {(validation["invoicedate"] === false) &&
                              <div className="custom-error">
                                Please select the Invoice Date
                              </div>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Supplier Invoice No. *</Label>
                          <InputGroup>
                            <Input
                              type="text"
                              autoFocus={true}
                              className="form-control"
                              id="suppname"
                              maxLength="150"
                              value={purchaseEntry.suppinvoiceno || ''}
                              onChange={e => {
                                setPurchaseEntry({
                                  ...purchaseEntry,
                                  suppinvoiceno : e.target.value
                                })
                                onChangeValidation("suppinvoiceno", e.target.value.trim())
                              }}
                            />
                            {(validation["suppinvoiceno"] === false) &&
                              <div className="custom-error">
                                Please enter the Supplier Invoice Number
                              </div>
                            }
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      {isEdit && <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Entry No.</Label>
                          <InputGroup>
                            <Input
                              type="text"
                              className="form-control"
                              disabled
                              value={purchaseEntry.id || ''}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      }
                    </Row>
                    <Row>
                      <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Supplier *</Label>
                            <Select
                              onChange={(e) => {
                                setPurchaseEntry({
                                  ...purchaseEntry,
                                  supplierid : e.value
                                })
                                setSelectedSupplier(e)
                                onChangeValidation("supplierid", e.value)
                              }}
                              value={selectedSupplier}
                              options={supplierList}
                              classNamePrefix="select2-selection"
                              isLoading={false}
                              id="productsupplier"
                            />
                            {(validation["supplierid"] === false) &&
                              <div className="custom-error">
                                Please select the Supplier
                              </div>
                            }
                        </FormGroup>
                      </Col>

                      <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Amount</Label>
                          <InputGroup>
                            <Input
                              type="text"
                              className="form-control"
                              id="productamount"
                              maxLength="20"
                              value={purchaseEntry.suppinvoiceamount || ''}
                              onChange={e => {
                                if(isNumber(e.target.value)){
                                  setPurchaseEntry({
                                    ...purchaseEntry,
                                    suppinvoiceamount : e.target.value
                                  })
                                }
                              }}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>

                      <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Payment Account</Label>

                          <COADropDown 
                              id={purchaseEntry.purchaseaccountid}
                              groupCode="CH,BA"
                              accountType="CASH"
                              selectOnChange={e =>{
                                setPurchaseEntry({
                                  ...purchaseEntry,
                                  purchaseaccountid : e.value,
                                })
                              }}
                              >
                            </COADropDown>
                        </FormGroup>
                      </Col>
                      {isEdit && <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Status</Label>
                          <InputGroup>
                            <Input
                              type="text"
                              className="form-control"
                              disabled
                              value={purchaseEntry.status || ''}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      }
                    </Row>

                    <div className="inner-repeater mb-2">
                      <div className="table-responsive">
                        <table style={{ width: "100%" }} className="0">
                          <tbody>
                            <tr className="custom-table-header">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="1">#</Col>
                                      <Col className="custom-table-header-cell" xs="9">Item</Col>
                                      <Col className="custom-table-header-cell" xs="2">Qty</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="2">Rate</Col>
                                      <Col className="custom-table-header-cell" xs="3">Gross</Col>
                                      <Col className="custom-table-header-cell" xs="2">Disc%</Col>
                                      <Col className="custom-table-header-cell" xs="2">Disc</Col>
                                      <Col className="custom-table-header-cell" xs="3">Net</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="2">CGST</Col>
                                      <Col className="custom-table-header-cell" xs="2">SGST</Col>
                                      <Col className="custom-table-header-cell" xs="2">IGST</Col>
                                      <Col className="custom-table-header-cell" xs="3">Total</Col>
                                      <Col className="custom-table-header-cell" xs="3">More..</Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            <SimpleBar style={{ height: "170px"}} autoHide={false}>
                            {(purchaseRows || []).map((formRow, key) => (
                              <tr key={key}>
                                <td>
                                  <Row className="no-gutters">
                                    <Col lg="4" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="1">
                                          <Input
                                            type="text"
                                            className="nopadd text-center"
                                            disabled
                                            value={formRow.idx}
                                          />
                                        </Col>
                                        <Col xs="9">
                                          <Select
                                            onChange={(e) => {
                                              const findExisting = purchaseRows.filter(each => each.productid == e.productid)
                                              if(findExisting.length > 0){
                                                setValidation({
                                                  ...validation,
                                                  ["duplicatepdt-"+formRow.idx]:true
                                                })
                                              }else{
                                                handleProductChangeV2(formRow.idx, e)
                                                validatePdtChange("pdtitem-"+formRow.idx, e.productid)
                                                setValidation({
                                                  ...validation,
                                                  ["duplicatepdt-"+formRow.idx]:false,
                                                  ["pdtitem-"+formRow.idx]:true
                                                })
                                              }
                                            }}
                                            options={productList}
                                            classNamePrefix="select2-selection"
                                            isLoading={false}
                                            formatOptionLabel={({ value, label, baseprice, mrp }) => (
                                              <div style={{ display: "flex", justifyContent: "space-between", alignContent:"center", alignItems:"center" }}>
                                                <div>{label}</div>
                                                <div style={{ marginLeft: "8px", color: "#aaa", fontSize:"11px"}}>{baseprice}{"/"}{mrp}</div>
                                              </div>
                                            )}
                                            id={"productentry-"+key}
                                            menuPortalTarget= {document.body}
                                            autoFocus={key==0?false:true}
                                            value={getSelectedProduct(formRow.idx)}
                                          />
                                          {(validation["pdtitem-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Please select an Item
                                            </div>
                                          }
                                          {(validation["duplicatepdt-"+formRow.idx] === true) &&
                                            <div className="custom-error">
                                              This item is already selected. Please choose a different one.
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="2">
                                          <Input
                                            type="text" //Qty
                                            id={"purch-qty-"+formRow.idx}
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleQtyChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productqty-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productqty)}
                                          />
                                          {(validation["productqty-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Qty
                                            </div>
                                          }
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg="4" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="2">
                                          <Input
                                            type="text" //Rate
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleRateChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productrate-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productrate)}
                                          />
                                          {(validation["productrate-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Rate
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Gross
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productgross)}
                                          />
                                        </Col>
                                        <Col xs="2">
                                          <Input
                                            type="text" //Disc %
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value) && Number(e.target.value) <=100){
                                                handleDiscPercentageChangeV2(formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productdiscpercentage)}
                                          />
                                        </Col>
                                        <Col xs="2">
                                          <Input
                                            type="text" // Disc
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleDiscountChangeV2(formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productdisc)}
                                          />
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" // Net
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productnet)}
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg="4" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="2">
                                          <Input
                                            type="text" // CGST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productcgst)}
                                          />
                                        </Col>
                                        <Col xs="2">
                                          <Input
                                            type="text" // SGST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productsgst)}
                                          />
                                        </Col>
                                        <Col xs="2">
                                          <Input
                                            type="text" //IGST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].productigst)}
                                          />
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Total
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(purchaseRows.filter(x => x["idx"]==formRow.idx)[0].producttotal)}
                                          />
                                        </Col>
                                        <Col xs="3" className="justify-content-center align-self-center text-center">
                                          <div className="add-remove-mob">
                                            <Button
                                              color="info"
                                              className="btn-sm btn-info ms-2 me-2"
                                              onClick={() => {
                                                //handleAddPurchaseRows()
                                                addMoreDetails(formRow.idx, false)
                                              }}
                                              disabled={formRow.idx > 199}
                                            >
                                              <i className="fas fa-plus"></i> 
                                            </Button>
                                            <Button
                                              color="danger"
                                              className="btn-sm btn-info "
                                              onClick={() => {
                                                handleRemoveOneRow(formRow, formRow.idx)
                                              }}
                                              disabled={purchaseRows.length == 1}
                                            >
                                              <i className="fas fa-minus"></i> 
                                            </Button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                    
                                  </Row>
                                  
                                </td>
                              </tr>
                            ))}
                            </SimpleBar>

                            <tr className="custom-table-footer">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="1"></Col>
                                      <Col className="pt-2 fw-medium display-10" xs="9">Total</Col>
                                      <Col className="" xs="2">
                                        <Input
                                            type="text" // total qty
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={purchaseEntry.totalqty || ''}
                                          />
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="2"></Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" //Gross
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={purchaseEntry.totalgross || ''}
                                        />
                                      </Col>

                                      <Col className="" xs="2">
                                      </Col>

                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // Disc
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={purchaseEntry.totaldisc || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" // net
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={purchaseEntry.totalnet || ''}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // CGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={purchaseEntry.totalcgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                      <Input
                                          type="text" // SGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={purchaseEntry.totalsgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // IGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={purchaseEntry.totaligst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="6">
                                        <Input
                                            type="text" // Grand Total
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={purchaseEntry.totaltotal.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>

                    <Row>
                      <Col lg="3">
                        <FormGroup className="mb-2">
                          <Label>Notes</Label>
                            <textarea
                              id="pdt-notes"
                              className="form-control"
                              rows="4"
                              maxLength="500"
                              value={purchaseEntry.notes || ''}
                              onChange={e => {
                                setPurchaseEntry({
                                  ...purchaseEntry,
                                  notes : e.target.value
                                })
                              }}
                            />
                        </FormGroup>
                      </Col>
                      <Col lg="9">
                        <Row>
                          <Col lg="4">
                            <FormGroup className="mb-2">
                              <Label>Freight Charges</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="freight-charges"
                                  maxLength="15"
                                  value={purchaseEntry.freightcharges || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value)){
                                      let grandtotaltemp = Number(purchaseEntry.totaltotal) + Number(e.target.value) + Number(purchaseEntry.othercharges) - Number(purchaseEntry.discounts) - Number(purchaseEntry.roundoff)
                                      setPurchaseEntry({
                                        ...purchaseEntry,
                                        freightcharges : e.target.value,
                                        balanceamount: (Number(grandtotaltemp) - Number(purchaseEntry.cashpaid)),
                                        grandtotal: Number(grandtotaltemp)
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="4">
                            <FormGroup className="mb-2">
                              <Label>Other Charges</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="other-charges"
                                  maxLength="20"
                                  value={purchaseEntry.othercharges || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value)){
                                      let grandtotaltemp = Number(purchaseEntry.totaltotal) + Number(e.target.value) + Number(purchaseEntry.freightcharges) - Number(purchaseEntry.discounts) - Number(purchaseEntry.roundoff)
                                      setPurchaseEntry({
                                        ...purchaseEntry,
                                        othercharges : e.target.value,
                                        balanceamount: (Number(grandtotaltemp) - Number(purchaseEntry.cashpaid)),
                                        grandtotal: Number(grandtotaltemp)
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="4">
                            <FormGroup className="mb-2">
                              <Label>Discounts</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="purchase-discounts"
                                  maxLength="20"
                                  value={purchaseEntry.discounts || ''}
                                  onChange={e => {
                                    let grandtotaltemp = Number(purchaseEntry.totaltotal) + Number(purchaseEntry.othercharges) + Number(purchaseEntry.freightcharges) - Number(e.target.value) - Number(purchaseEntry.roundoff)
                                    if(isNumber(e.target.value)){
                                      setPurchaseEntry({
                                        ...purchaseEntry,
                                        discounts : e.target.value,
                                        balanceamount: (Number(grandtotaltemp) - Number(purchaseEntry.cashpaid)),
                                        grandtotal: Number(grandtotaltemp)
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4">
                            <FormGroup className="mb-2">
                              <Label>Cash Paid</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  disabled={isEdit}
                                  id="cashpaid"
                                  maxLength="20"
                                  value={purchaseEntry.cashpaid || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value)){
                                      setPurchaseEntry({
                                        ...purchaseEntry,
                                        cashpaid : e.target.value,
                                        balanceamount: (Number(purchaseEntry.grandtotal) - Number(e.target.value))
                                      })
                                    }
                                  }}
                                />
                                {isEdit && <Button id="disabledcashpaid" onClick={()=>{}}>
                                  <i className="bx bx-question-mark font-size-16"></i> 
                                </Button> }
                              </InputGroup>
                              
                            </FormGroup>
                            {isEdit && <Tooltip placement="top" isOpen={tooltipOpen} target="disabledcashpaid" toggle={toggle}>
                                Please use Payments to edit the Cash Paid
                            </Tooltip> }
                          </Col>

                          <Col lg="4">
                            <FormGroup className="mb-2">
                              <Label>Balance Amount</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="pdt-balance-amt"
                                  disabled
                                  value={purchaseEntry.balanceamount.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>

                          <Col lg="4">
                            <FormGroup className="mb-2">
                              <Label>Round Off</Label>
                              <InputGroup className="">

                                <div className="d-flex square-switch align-self-center">
                                  <input
                                    type="checkbox"
                                    id="square-switch1"
                                    switch="none"
                                    checked={roundOffCheck}
                                    onChange={() => {
                                      if(!roundOffCheck){
                                        let grandtotaltemp = Number(purchaseEntry.totaltotal) + Number(purchaseEntry.othercharges) + Number(purchaseEntry.freightcharges) - Number(purchaseEntry.discounts)
                                        const grandtotaltempafterround = Math.round(grandtotaltemp)
                                        const roundofftemp = Number(grandtotaltempafterround - grandtotaltemp).toFixed(2)
                                        setPurchaseEntry({
                                          ...purchaseEntry,
                                          roundoff : roundofftemp,
                                          balanceamount: (Number(grandtotaltempafterround) - Number(purchaseEntry.cashpaid)),
                                          grandtotal: Number(grandtotaltempafterround)
                                        })
                                      }
                                      else{
                                        let grandtotaltemp = Number(purchaseEntry.totaltotal) + Number(purchaseEntry.othercharges) + Number(purchaseEntry.freightcharges) - Number(purchaseEntry.discounts)
                                        setPurchaseEntry({
                                          ...purchaseEntry,
                                          roundoff : "0.00",
                                          balanceamount: (Number(grandtotaltemp) - Number(purchaseEntry.cashpaid)),
                                          grandtotal: Number(grandtotaltemp)
                                        })
                                      }
                                      setRoundOffCheck(!roundOffCheck)
                                    }}
                                  />
                                  <label
                                    htmlFor="square-switch1"
                                    data-on-label="Yes"
                                    data-off-label="No"
                                    className="mb-0"
                                  />
                                </div>

                                <Input
                                  type="text"
                                  className="form-control"
                                  id="purchase-roundoff"
                                  maxLength="20"
                                  value={purchaseEntry.roundoff || ''}
                                  onChange={e => {
                                    let grandtotaltemp = Number(purchaseEntry.totaltotal) + Number(purchaseEntry.othercharges) + Number(purchaseEntry.freightcharges) - Number(e.target.value) - Number(purchaseEntry.discounts)
                                    if(isNumber(e.target.value)){
                                      setPurchaseEntry({
                                        ...purchaseEntry,
                                        roundoff : e.target.value,
                                        balanceamount: (Number(grandtotaltemp) - Number(purchaseEntry.cashpaid)),
                                        grandtotal: Number(grandtotaltemp)
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4"></Col>
                          <Col lg="4"></Col>
                          <Col lg="4">
                            <FormGroup className="mb-2">
                              <Label>Grand Total</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="grandtotal"
                                  disabled
                                  value={purchaseEntry.grandtotal.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      
                    </Row>

                    {(validation["invalidsum"] === false) &&
                      <div className="text-center clearfix custom-error mb-2">
                        Grand Total & Invoice Total doesnt match. Please check.
                      </div>
                    }
                    {(validation["invalidpaidamt"] === false) &&
                      <div className="text-center clearfix custom-error mb-2">
                        Paid amount is more than Total Amount. Please check.
                      </div>
                    }
                    
                    {!isEdit &&
                    <Row>
                      <Col md="3" className="align-self-center">
                      </Col>
                      <Col md="6">
                        <div className="text-center clearfix">
                          <Button
                            color="success"
                            disabled={savedSuccessFully}
                            className="btn w-lg btn-success me-2"
                            onClick={() => {
                              addPurchaseEntry()
                            }}
                            >
                              SAVE PURCHASE
                          </Button>
                          <Button
                            color="secondary"
                            className="btn w-lg btn-info me-2"
                            disabled={savedSuccessFully}
                            onClick={() => {
                              draftPurchaseEntry()
                            }}
                            >
                              SAVE AS DRAFT
                          </Button>
                          {savedSuccessFully && <Button
                            color="primary"
                            className="btn w-lg btn-primary "
                            onClick={() => {
                              addNewPurchase()
                            }}
                            >
                              ADD NEW PURCHASE
                          </Button> }
                        </div>
                      </Col>
                      <Col md="3">
                      </Col>
                    </Row>
                    }
                    {isEdit &&
                    <Row>
                      <Col>
                      </Col>
                      <Col>
                        <div className="text-center clearfix">
                          <Button
                            color="success"
                            className="btn w-lg btn-success me-2"
                            onClick={() => {
                              updatePurchaseEntry()
                            }}
                            >
                              SAVE PURCHASE
                          </Button>
                          {purchaseEntry.status == "DRAFT" ? <Button
                            color="secondary"
                            className="btn w-lg btn-info me-2"
                            onClick={() => {
                              updateDraftPurchaseEntry()
                            }}
                            >
                              SAVE AS DRAFT
                          </Button>
                          : null
                          }
                        </div>
                      </Col>
                      <Col>
                      </Col>
                    </Row>
                    }
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <PurchaseMoreDrawer
          onClose={onDrawerClose} 
          onNewlyAddedValue={onNewlyAddedValue}
          detailsForEdit={null}
          isEdit={false}
          currentItem={currentItemForMoreDetails}
          open={open}
          ecomEnabled={ecomEnabled}
          profitPercentageSettings={profitPercentageSettings}
        />
      </ReactDrawer>

      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
      {showSuccessPopUp ? (
        <SweetAlert
          title="Success!"
          showCancel
          success
          cancelBtnBsStyle="warning"
          confirmBtnBsStyle="success"
          confirmBtnText="Add New Entry"
          cancelBtnText="Continue Editing"
          onConfirm={() => {
            onCreateNewPurchase()
          }}
          onCancel={() => {
            onContinueEditing()
          }}
        >
          {successMessage}
        </SweetAlert>
      ) : null}

    </React.Fragment>
  )
}

export default PurchaseEntry
